<template>
  <div class="app-container" @click="closeTree">
    <div class="app-content-wrap">
      <el-header class="right-menu-name" height="38px"
        >设计选型 <i class="el-icon-arrow-right"></i>
        <span>需求配置</span></el-header
      >
      <div class="app-content">
        <!-- top -->
        <div class="content-top">
          <!-- top-left -->
          <div class="content-top-left">
            <div class="tab">
              <div
                class="tab-meter-item"
                v-for="(item, index) in tabs"
                @click="changeTab(item)"
                :key="index"
                :class="{ active: tab === item.code }"
              >
                {{ item.label }}
                <img
                  v-show="
                    tab === '01' &&
                    index === 0 &&
                    selectAndNot[1] > 0 &&
                    selectAndNot[1] >= selectAndNot[3]
                  "
                  style="margin-left: 2px"
                  src="@/assets/img/meterSelection/gou.svg"
                />
                <img
                  v-show="
                    tab === '02' &&
                    index === 0 &&
                    selectAndNot[1] > 0 &&
                    selectAndNot[1] >= selectAndNot[3]
                  "
                  style="margin-left: 2px"
                  src="@/assets/img/meterSelection/gou-green.svg"
                />
              </div>
            </div>
            <div class="content-title">基本配置</div>
            <div class="content-top-left-form">
              <CategoryInfo
                ref="categoryInfo"
                @getImg="getImg"
                @getDetail="resetData"
              />
              <el-form
                :inline="true"
                class="content-top-left-form-wrap"
                label-width="72px"
              >
                <el-form-item label="仪表类型：">
                  <el-select
                    v-model="dataForm.instruId"
                    clearable
                    popper-class="meter-form-select-popper"
                    placeholder="仪表类型"
                    @change="instruChange"
                  >
                    <el-option
                      v-for="(item, index) in detailObj.instruTypes || []"
                      :key="index"
                      :label="item.instruType"
                      :value="item.instruId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <br />
                <el-form-item label="产品偏好：">
                  <el-select
                    v-model="dataForm.preferType"
                    clearable
                    popper-class="meter-form-select-popper"
                    placeholder="产品偏好"
                  >
                    <el-option label="国产品牌" value="国产品牌"> </el-option>
                    <el-option label="外资品牌" value="外资品牌"> </el-option>
                  </el-select>
                </el-form-item>
                <br />
                <el-form-item label="附件：" v-show="tab === '02'">
                  <UploadFile
                    ref="uploadFile"
                    :limit="1"
                    accept=".rar, .zip, .doc, .docx, .pdf, .jpg"
                    buttonText="上传文件"
                    :beforeUpload="beforeUpload"
                    tip="支持扩展名：.rar .zip .doc .docx .pdf .jpg (20M以内)"
                    :handleExceedText="'当前限制选择1个文件，本次选择了1个文件，共选择了2个文件，多个文件请打包压缩上传'"
                    @onSuccess="onSuccess"
                    :showFileList="false"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- top-right -->
          <div class="content-top-right">
            <!-- 安装方式示意图 -->
            <div class="content-show-img" v-show="categoryThirdImg">
              <!-- 显示图片 -->
              <ImageCom
                :preview="true"
                style="width: 190px; height: 190px"
                :src="categoryThirdImg"
              />
              <div class="tip">安装方式示意图</div>
            </div>
            <!-- 仪表产品示意图 -->
            <div class="content-show-img" v-show="diagramImgs">
              <!-- 显示图片 -->
              <ImageCom
                :preview="true"
                style="width: 190px; height: 190px"
                :src="diagramImgs"
              />
              <div class="tip">仪表产品示意图</div>
            </div>
          </div>
        </div>
        <!-- bottom -->
        <div class="content-bottom">
          <!-- bottom-left -->
          <div class="content-bottom-left">
            <div class="flex-sp ac">
              <div class="content-title">
                参数配置<span class="content-title-count"
                  >可选/已选：{{ selectAndNot[0] }}/{{ selectAndNot[1] }}</span
                >
              </div>

              <div class="opts" v-if="tab === '01'">
                <div
                  class="btn-primary"
                  @click="clearSelection"
                  :class="{ 'btn-plain': selectAndNot[2] === 0 }"
                >
                  清空筛选
                </div>
              </div>
            </div>

            <div class="content-config" v-if="tab === '01'">
              <!-- 参数组下的参数项 -->
              <div class="content-config-attr">
                <div class="config-menu">
                  <div>
                    {{
                      detailObj.attrGroups &&
                      detailObj.attrGroups[attrGroupsIndex] &&
                      detailObj.attrGroups[attrGroupsIndex].attrGroupName
                    }}
                    <span class="menu-count"
                      >{{
                        (detailObj.attrGroups && detailObj.attrGroups.length) ||
                        0
                      }}条</span
                    >
                  </div>

                  <el-popover
                    popper-class="meter-group-wrap-popper"
                    placement="bottom-start"
                    trigger="hover"
                  >
                    <div class="meter-group-wrap">
                      <div
                        class="meter-group-item"
                        :class="{ active: attrGroupsIndex === index }"
                        v-for="(item, index) in detailObj.attrGroups || []"
                        :key="index"
                        @click="changeGroup(index)"
                      >
                        {{ item.attrGroupName }} <i class="el-icon-check"></i>
                      </div>
                    </div>
                    <div class="btn-primary" slot="reference">
                      <span
                        class="next-sign"
                        v-if="
                          detailObj.attrGroups &&
                          detailObj.attrGroups[attrGroupsIndex + 1] &&
                          detailObj.attrGroups[attrGroupsIndex + 1]
                            .attrGroupName
                        "
                        >下一个：</span
                      >
                      <span class="btn-text">
                        <Tooltips
                          :innerContent="
                            (detailObj.attrGroups &&
                              detailObj.attrGroups[attrGroupsIndex + 1] &&
                              detailObj.attrGroups[attrGroupsIndex + 1]
                                .attrGroupName) ||
                            (detailObj.attrGroups &&
                              detailObj.attrGroups[attrGroupsIndex] &&
                              detailObj.attrGroups[attrGroupsIndex]
                                .attrGroupName) ||
                            '请选择'
                          "
                        />
                        <!-- {{
                        (detailObj.attrGroups &&
                          detailObj.attrGroups[attrGroupsIndex + 1] &&
                          detailObj.attrGroups[attrGroupsIndex + 1]
                            .attrGroupName) ||
                        (detailObj.attrGroups &&
                          detailObj.attrGroups[attrGroupsIndex] &&
                          detailObj.attrGroups[attrGroupsIndex]
                            .attrGroupName) ||
                        "请选择"
                      }} -->
                      </span>
                      <i class="el-icon-arrow-down"></i>
                    </div>
                  </el-popover>
                </div>
                <div class="attr-item-wrap">
                  <div
                    class="attr-item"
                    :class="{
                      active: attrIndex === index,
                      selected: isAllChecked(item),
                    }"
                    v-for="(item, index) in attrItems"
                    @click="changeAttr(index)"
                    :key="index"
                  >
                    <div class="attr-name">
                      <Tooltips :innerContent="item.attrName" />
                      <div class="required" :class="{ red: item.required }">
                        {{ item.required ? "必填" : "非必填" }}
                      </div>
                    </div>
                    <div class="attr-value">
                      <template v-if="item.attrValue || item.inputValue">
                        {{ item.inputValue ? "已输入" : "已选择" }} ：<Tooltips
                          :innerContent="item.attrValue || item.inputValue"
                        />
                      </template>
                      <template v-if="item.unit">
                        {{ item.attrValue || item.inputValue ? "｜" : ""
                        }}{{ item.unit || "-" }}
                      </template>
                    </div>
                  </div>
                </div>
                <div class="empty" v-if="attrItems.length === 0">
                  暂无参数配置
                </div>
              </div>

              <!-- 参数选择 -->
              <div class="content-config-attr-row">
                <div class="row-header">
                  <span style="line-height: 24px">可选参数值</span>
                  <div
                    class="row-unit"
                    v-if="
                      attrItems[attrIndex] &&
                      attrItems[attrIndex].units &&
                      attrItems[attrIndex].units.length
                    "
                  >
                    单位：
                    <el-select
                      v-model="attrItems[attrIndex].unit"
                      clearable
                      @change="goNextAttr()"
                      popper-class="meter-form-select-popper"
                      placeholder="请选择单位"
                    >
                      <template v-if="attrItems[attrIndex].limitUnit.length">
                        <el-option
                          v-for="(item, index) in attrItems[attrIndex]
                            .limitUnit"
                          :key="`A${index}${item}`"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </template>
                      <template v-else>
                        <el-option
                          v-for="(item, index) in attrItems[attrIndex].units ||
                          []"
                          :key="`B${index}${item}`"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
                <div class="row-wrap" v-if="attrItems[attrIndex]">
                  <el-input
                    :maxlength="50"
                    v-if="attrItems[attrIndex].inputMode === 1"
                    v-model.trim="attrItems[attrIndex].inputValue"
                    @blur="blurAttrValue(attrItems[attrIndex])"
                    placeholder="请输入你需要的参数值"
                  ></el-input>
                  <div class="row-configDatas">
                    <div
                      class="row-item"
                      :class="{
                        active: item === attrItems[attrIndex].attrValue,
                      }"
                      v-for="(item, index) in attrItems[attrIndex]
                        .attrValueList"
                      :key="index"
                      @click="changeAttrValue(item, attrItems[attrIndex])"
                    >
                      <Tooltips :innerContent="item" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="tab === '02'" class="content-table">
              <el-table
                ref="contentTable"
                style="width: 100%"
                border
                :resizable="false"
                :summary-method="summaryMethod"
                :show-summary="true"
                :cell-class-name="cellClassName"
                :span-method="arraySpanMethod"
                :data="dataList"
                :height="520"
              >
                <el-table-column
                  width="65"
                  align="center"
                  show-overflow-tooltip
                  property="attrGroupName"
                  label="参数组"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  min-width="100"
                  align="center"
                  show-overflow-tooltip
                  property="attrName"
                  label="参数名称"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  min-width="100"
                  align="center"
                  show-overflow-tooltip
                  property="attrValue"
                  label="参数值"
                  :resizable="false"
                >
                  <template slot-scope="scope">
                    {{ scope.row.attrValue || scope.row.inputValue }}
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="100"
                  align="center"
                  show-overflow-tooltip
                  property="unit"
                  label="单位"
                  :resizable="false"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- bottom-right -->
          <div class="content-bottom-right">
            <div class="flex-sp ac">
              <div class="content-title">参数应用位置示意图</div>
              <div class="btn-next" @click="goNext" v-if="tab === '01'">
                下一步
              </div>
            </div>
            <div class="img-position-wrap">
              <img
                :src="detailObj.diagramImg"
                ref="positionImg"
                v-if="detailObj.diagramImg"
                alt=""
              />

              <div class="no_show_message" v-else>
                <img
                  src="@/assets/img/good/noGood.png"
                  style="width: 150px; height: 150px"
                  alt="暂无参数应用位置示意图"
                />
                <div>暂无上传参数应用位置示意图</div>
              </div>
              <div
                class="img-pos"
                :class="{
                  show:
                    selectAttrIds.includes(item.attrId) ||
                    (attrItems[attrIndex] &&
                      attrItems[attrIndex].attrId === item.attrId),
                  current:
                    attrItems[attrIndex] &&
                    attrItems[attrIndex].attrId === item.attrId,
                }"
                v-for="(item, index) in detailObj.diagramImgPositions"
                :key="index"
                :style="itemPos(item)"
              >
                <img
                  class="default"
                  src="@/assets/img/meterSelection/pos-img.png"
                />
                <img
                  class="current"
                  src="@/assets/img/meterSelection/pos-img-current.png"
                />
              </div>
            </div>
            <div v-if="tab === '02'" class="img-opt">
              <div class="btn-next btn-primary" @click="tab = '01'">
                修改返回上一步
              </div>
              <div
                class="btn-next"
                v-loading="submitLoading"
                @click="goSumbmit"
              >
                提交需求
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SupportIcon />
  </div>
</template>

<script>
import Tooltips from '@/components/tooltipShow'
import ImageCom from '@/components/image/index.vue'
import UploadFile from '@/components/upload/file.vue'
import CategoryInfo from './components/meterConfig.vue'
import SupportIcon from './components/supportIcon.vue'

export default {
  components: {
    Tooltips,
    ImageCom,
    CategoryInfo,
    UploadFile,
    SupportIcon
  },
  data () {
    return {
      dataList: [],
      tabs: [
        {
          label: '可选配置',
          code: '01'
        },
        {
          label: '已完成',
          code: '02'
        }
      ],
      categoryThirdImg: '', // 安装方式示意图
      diagramImgs: '', // 仪表产品示意图
      tab: '01',
      dataForm: {
        instruId: '',
        preferType: '',
        userRemark: '', // 备注
        attachUrl: '' // 附件地址
      },
      detailObj: {},
      attrGroupsIndex: 0, // 属性组的序号
      attrIndex: 0, // 属性项的序号
      submitLoading: false,
      imgSize: {
        width: 0,
        height: 0,
        rate: 0
      }
    }
  },
  mounted () {
    this.getDetail(this.$route.query.thirdCategoryId)
  },
  computed: {
    attrItems () {
      return this.detailObj.attrGroups
        ? this.detailObj.attrGroups[this.attrGroupsIndex].attrs
        : []
    },
    selectAttrIds () {
      // 已选的值统计数量
      const attrIds = []
      this.detailObj.attrGroups.forEach((group) => {
        if (group.attrs && group.attrs.length) {
          const selectAttrs = group.attrs.filter((item) => {
            // 有单位可选的话要算上单位选择完才算已选
            return this.isAllChecked(item)
          })
          attrIds.push(...selectAttrs.map((item) => item.attrId))
        }
      })
      return attrIds
    },
    selectAndNot () {
      if (this.detailObj.attrGroups && this.detailObj.attrGroups.length) {
        // 总共需要填写的数量[0]
        const count = this.detailObj.attrGroups.reduce((attrLength, group) => {
          return attrLength + ((group.attrs && group.attrs.length) || 0)
        }, 0)

        // 已选的值统计数量[1]
        const selectCount = this.detailObj.attrGroups.reduce(
          (attrLength, group) => {
            if (group.attrs && group.attrs.length) {
              const selectAttrs = group.attrs.filter((item) => {
                // 有单位可选的话要算上单位选择完才算已选
                if (item.units && item.units.length) {
                  // 输入&下拉模式下默认值有效
                  return (item.attrValue || item.inputValue) && item.unit
                } else {
                  return item.attrValue || item.inputValue
                }
              })
              return attrLength + selectAttrs.length
            }
            return attrLength
          },
          0
        )

        // 有选单位或值的数量，用于清空筛选[2]
        const selectCountNotDefault = this.detailObj.attrGroups.reduce(
          (attrLength, group) => {
            if (group.attrs && group.attrs.length) {
              const selectAttrs = group.attrs.filter((item) => {
                // 还要判断单位是否可选已选,可选已选的也算作输入，可以清空筛选
                if (item.units && item.units.length) {
                  return item.attrValue || item.inputValue || item.unit
                } else {
                  return item.attrValue || item.inputValue
                }
              })
              return attrLength + selectAttrs.length
            }
            return attrLength
          },
          0
        )

        // 必填跟选了值的总数[3]
        const selectCountRequired = this.detailObj.attrGroups.reduce(
          (attrLength, group) => {
            if (group.attrs && group.attrs.length) {
              const selectAttrs = group.attrs.filter((item) => {
                return item.required ? true : item.attrValue || item.inputValue
              })
              return attrLength + selectAttrs.length
            }
            return attrLength
          },
          0
        )
        return [count, selectCount, selectCountNotDefault, selectCountRequired]
      }
      return [0, 0, 0, 0]
    }
  },
  methods: {
    // 判断是否完成输入
    isAllChecked (item) {
      // 有单位可选的话要算上单位选择完才算已选
      if (item.units && item.units.length) {
        // 输入&下拉模式下默认值有效
        return (item.attrValue || item.inputValue) && item.unit
      } else {
        return item.attrValue || item.inputValue
      }
    },
    // 设置分类-安装方式示意图
    getImg (img) {
      this.categoryThirdImg = img
    },
    // 关闭类目弹窗方法
    closeTree () {
      this.$refs.categoryInfo && this.$refs.categoryInfo.hideTree()
    },
    // 通过三级类目获取详情配置参数
    getDetail (categoryId) {
      this.$http
        .get(
          `/front/cross/commodity-user/design/product/config?categoryId=${categoryId}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            // console.log(res.data)
            this.detailObj = res.data || {}

            // 赋值默认参数，传送接口用
            if (this.detailObj.attrGroups && this.detailObj.attrGroups.length) {
              this.detailObj.attrGroups.forEach((item) => {
                if (item.attrs && item.attrs.length) {
                  item.attrs.forEach((attr) => {
                    const attrValues = this.detailObj.attrConfigRows.map(
                      (attrValue) => {
                        const attrObj = attrValue.configDatas.find(
                          (attrItem) => {
                            return attrItem.attrId === attr.attrId
                          }
                        )

                        return attrObj ? attrObj.valueDatas : []
                      }
                    )
                    const attrValueList = [...new Set(attrValues.flat())]
                    const defaultValue =
                      attr.inputMode === 1
                        ? attr.defaultValue
                        : attr.inputMode === 2 &&
                          attrValueList.includes(attr.defaultValue)
                          ? attr.defaultValue
                          : ''

                    // 过滤一些非法的默认值
                    attr.defaultValue = defaultValue

                    // 赋值默认参数，传送接口用
                    this.$set(attr, 'unit', '')
                    this.$set(attr, 'limitUnit', []) // 有此数组时限制只能选择此数组内数据

                    // 单位只有一个的默认选上
                    this.$set(
                      attr,
                      'unit',
                      attr.units && attr.units.length === 1 ? attr.units[0] : ''
                    )

                    this.$set(attr, 'attrValueList', attrValueList)

                    // 如果下拉选型中有默认值，则默认选中,根据默认值设置参数
                    if (attrValueList.includes(attr.defaultValue)) {
                      this.$set(attr, 'attrValue', attr.defaultValue)
                      this.$set(attr, 'inputValue', '')

                      // 更新单位限制
                      this.$nextTick(() => {
                        this.updateLimitUnit(attr)
                      })
                    } else if (attr.inputMode === 1) {
                      this.$set(attr, 'attrValue', '')
                      this.$set(attr, 'inputValue', attr.defaultValue)
                    } else {
                      this.$set(attr, 'attrValue', '')
                      this.$set(attr, 'inputValue', '')
                    }
                  })
                }
              })
            }

            this.$nextTick(() => {
              // 获取图片的原始宽高
              const img = this.$refs.positionImg
              if (img) {
                if (img.complete) {
                  this.imgSize = {
                    width: img.naturalWidth,
                    height: img.naturalHeight,
                    rate:
                      img.naturalWidth >= img.naturalHeight
                        ? img.getBoundingClientRect().width / img.naturalWidth
                        : img.getBoundingClientRect().height /
                          img.naturalHeight
                  }
                } else {
                  img.onload = () => {
                    this.imgSize = {
                      width: img.naturalWidth,
                      height: img.naturalHeight,
                      rate:
                        img.naturalWidth >= img.naturalHeight
                          ? img.getBoundingClientRect().width / img.naturalWidth
                          : img.getBoundingClientRect().height /
                            img.naturalHeight
                    }
                  }
                }
              }
            })
          }
        })
    },
    // 仪表类型切换，获取产品示意图
    instruChange () {
      const instruObj = this.detailObj.instruTypes.find(
        (item) => item.instruId === this.dataForm.instruId
      )
      if (instruObj && instruObj.diagramImgs) {
        this.diagramImgs = (instruObj.diagramImgs || []).join(',')
      } else {
        this.diagramImgs = ''
      }
    },
    // 切换参数组
    changeGroup (index) {
      if (this.attrGroupsIndex === index) return
      this.attrGroupsIndex = index

      // 重置参数配置序号
      this.attrIndex = 0

      // 关闭类目树选择窗口
      // this.closeTree()
    },
    // 切换参数项
    changeAttr (index) {
      this.attrIndex = index
    },
    // 自动切换到下一个可选参数，跳过有默认值及有可选项及有单位没选单位的
    goNextAttr () {
      // 参数组的数量不变
      const attrGroupLength = this.detailObj.attrGroups.length

      // 当前参数长度和参数组长度,及模拟跳转的组和参数序号
      let attrGroupsIndex = this.attrGroupsIndex
      let attrIndex = this.attrIndex

      // 查看当前数据是否已填写完
      let allFill = this.checkAllFilled(
        this.detailObj.attrGroups[attrGroupsIndex].attrs[attrIndex]
      )

      // 进行跳转，找到下一个能跳转的组和参数，没有则不动了
      while (allFill) {
        // 计数放到循环里，避免切换组后参数项数量变了
        let attrItemLength =
          this.detailObj.attrGroups[attrGroupsIndex].attrs.length
        // 判断是否为最后一个参数组的最后一个参数
        if (attrItemLength - 1 === attrIndex) {
          // 判断是否为最后一个参数组
          if (attrGroupLength - 1 === attrGroupsIndex) {
            // 切换到第一个组的第一个参数
            attrGroupsIndex = 0

            // 重置参数配置序号
            attrIndex = 0
          } else {
            // 切换到下一个组的第一个参数
            attrGroupsIndex += 1
            attrIndex = 0
          }
        } else {
          // 切换到当前组下一个参数
          attrIndex += 1
        }

        allFill = this.checkAllFilled(
          this.detailObj.attrGroups[attrGroupsIndex].attrs[attrIndex]
        )
        if (
          attrGroupsIndex === this.attrGroupsIndex &&
          attrIndex === this.attrIndex
        ) {
          console.log('全都填完了')
          break
        }
      }

      // 进行跳转操作
      this.attrGroupsIndex = attrGroupsIndex
      this.attrIndex = attrIndex
    },
    // 检查当前参数项是否都填写完成
    checkAllFilled (attr) {
      if (attr.attrValue || attr.inputValue) {
        if (attr.units && attr.units.length) {
          return !!attr.unit
        }
        return true
      }
      return false
    },
    // 手动录入可选值
    blurAttrValue (attrItem) {
      if (attrItem.attrValue && !attrItem.inputValue) {
        return
      }
      if (attrItem.attrValueList.includes(attrItem.inputValue)) {
        this.$message.warning('可选参数值中有对应的输入值')
        attrItem.attrValue = attrItem.inputValue
        attrItem.inputValue = ''

        // 调整可选参数
        this.adjustAttrValues(attrItem)
      } else {
        attrItem.attrValue = ''
      }

      // 查看有无影响单位，是否匹配，不在则清空
      this.updateLimitUnit(attrItem)

      // 跳转下个可输入参数
      this.goNextAttr()
    },
    // 修改可选参数值
    changeAttrValue (val, itemObj) {
      if (itemObj.attrValue) {
        itemObj.attrValue = itemObj.attrValue === val ? '' : val
      } else {
        itemObj.attrValue = val
      }

      // 清空输入框
      itemObj.inputValue = ''

      // 调整可选参数
      this.adjustAttrValues(itemObj)

      // 查看有无影响单位，是否匹配，不在则清空
      this.updateLimitUnit(itemObj)

      // 跳转下个可输入参数
      this.goNextAttr()
    },
    // 参数修改更新单位可选值
    updateLimitUnit (itemObj) {
      // 寻找当前影响的数据
      this.detailObj.attrGroups.forEach((item) => {
        if (item.attrs && item.attrs.length) {
          item.attrs.forEach((attr) => {
            if (
              attr.unitLimits &&
              attr.unitLimits.length &&
              attr.unitLimits[0].attrId === itemObj.attrId
            ) {
              // 如果itemObj的值在影响参数值中，限制attr的单位
              const values = itemObj.attrValue || itemObj.inputValue
              const limitFind = attr.unitLimits.find((limitObj) => {
                return limitObj.attrValues.includes(values)
              })
              if (limitFind) {
                this.$set(attr, 'limitUnit', limitFind.units || [])
                // 如果当前影响参数的单位不在下拉中则清空
                if (
                  attr.limitUnit.length &&
                  attr.unit &&
                  !attr.limitUnit.includes(attr.unit)
                ) {
                  this.$set(attr, 'unit', '')
                }
              } else {
                this.$set(attr, 'limitUnit', [])
              }
            }
          })
        }
      })
    },
    // 清空筛选
    clearSelection () {
      if (this.selectAndNot[2] === 0) return

      this.$confirm('清空后无法恢复，请确认是否继续！', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'comfirm-box',
        type: 'warning'
      }).then(() => {
        this.detailObj.attrGroups.forEach((item) => {
          item.attrs.forEach((attr) => {
            attr.unit = ''
            attr.attrValue = ''
            attr.inputValue = ''
            attr.limitUnit = []
          })
        })

        // 重置参数
        this.adjustAttrValues()
      })
    },
    // 根据现有参数自动调整相应的可选参数
    adjustAttrValues (itemObj) {
      if (this.detailObj.attrGroups && this.detailObj.attrGroups.length) {
        // 定义所有配置行，以防数据丢失
        let attrConfigRows = JSON.parse(
          JSON.stringify(this.detailObj.attrConfigRows)
        )

        // 如果传了当前修改对象，则先适配当前修改对象
        if (itemObj && itemObj.attrValue) {
          attrConfigRows = attrConfigRows.filter((row) => {
            const configObj = row.configDatas.find(
              (config) => config.attrId === itemObj.attrId
            )
            return ((configObj && configObj.valueDatas) || []).includes(
              itemObj.attrValue
            )
          })

          // 根据当前选择的结果重新赋值参数列表，筛选attrValueList
          this.changeAttrValueList(attrConfigRows)

          // 不在配置行参数中的attrValue通通清空
          this.detailObj.attrGroups.forEach((item) => {
            if (item.attrs && item.attrs.length) {
              item.attrs.forEach((attr) => {
                if (
                  attr.attrValue &&
                  !attr.attrValueList.includes(attr.attrValue)
                ) {
                  attr.attrValue = ''
                }
              })
            }
          })
        }

        // 筛选出有当前值的配置行
        this.detailObj.attrGroups.forEach((item) => {
          if (item.attrs && item.attrs.length) {
            item.attrs.forEach((attr) => {
              if (attr.attrValue) {
                attrConfigRows = attrConfigRows.filter((row) => {
                  const configObj = row.configDatas.find(
                    (config) => config.attrId === attr.attrId
                  )
                  return ((configObj && configObj.valueDatas) || []).includes(
                    attr.attrValue
                  )
                })
              }
            })
          }
        })

        // 根据现有的配置行重新赋值参数列表
        this.changeAttrValueList(attrConfigRows)
      }
    },
    // 根据配置行调整可选参数
    changeAttrValueList (configRows) {
      this.detailObj.attrGroups.forEach((item) => {
        if (item.attrs && item.attrs.length) {
          item.attrs.forEach((attr) => {
            const attrValues = configRows.map((attrValue) => {
              const attrObj = attrValue.configDatas.find((attrItem) => {
                return attrItem.attrId === attr.attrId
              })

              return attrObj ? attrObj.valueDatas : []
            })

            // 赋值默认参数，传送接口用
            this.$set(attr, 'attrValueList', [...new Set(attrValues.flat())])
          })
        }
      })
    },
    // 切换为已完成或返回上一步
    changeTab (item) {
      if (item.code === '02') {
        this.goNext()
      } else {
        this.tab = '01'
      }
    },
    // 下一步，校验必填项的是不是都填完了
    goNext () {
      let isError = false
      let isUnitError = false
      this.detailObj.attrGroups.forEach((item) => {
        if (item.attrs && item.attrs.length) {
          item.attrs.forEach((attr) => {
            const hasInput =
              attr.attrValue || (attr.inputMode === 1 && attr.inputValue)
            // 必填但是没值报错
            if (attr.required) {
              if (hasInput) {
                // 填了
              } else {
                isError = true
              }
            }
            // 有值但是单位没选报错
            if (attr.units && attr.units.length && !attr.unit && hasInput) {
              isUnitError = true
            }
          })
        }
      })

      if (isError && isUnitError) {
        this.$message.warning('请检查必填参数及单位是否填写完成')
      } else if (isUnitError) {
        this.$message.warning('请检查单位是否填写完成')
      } else if (isError) {
        this.$message.warning('请检查必填参数是否填写完成')
      } else {
        // 组装table数据
        this.addTableData()
        this.tab = '02'
      }
    },
    // 组装table数据
    addTableData () {
      this.dataList = []
      this.detailObj.attrGroups.forEach((item) => {
        item.attrs.forEach((attr) => {
          this.dataList.push({
            attrGroupId: item.attrGroupId,
            attrGroupName: item.attrGroupName,
            ...attr
          })
        })
      })

      this.merage()
    },
    // 表格参数组合并
    merage () {
      this.cghthArr = []
      let unikeyPos = 0
      for (let i = 0; i < this.dataList.length; i++) {
        // 第一行必须存在
        if (i === 0) {
          this.cghthArr.push(1)
        } else {
          // 判断当前元素与上一个元素cghth是否相同,并且uniKey是一样
          if (
            this.dataList[i].attrGroupId === this.dataList[i - 1].attrGroupId
          ) {
            this.cghthArr[unikeyPos] += 1
            this.cghthArr.push(0)
          } else {
            this.cghthArr.push(1)
            unikeyPos = i
          }
        }
      }
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 操作列进行合并
      if (column.property === 'attrGroupName') {
        const row1 = this.cghthArr && this.cghthArr[rowIndex]
        return {
          rowspan: row1,
          colspan: 1
        }
      }
    },
    cellClassName ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'attrGroupName') {
        return 'vertical-rl'
      }
    },
    summaryMethod (param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '其他'
          return
        }
        if (index === 1) {
          sums[index] = '备注'
          return
        }

        // 表格行合并
        this.$nextTick(() => {
          const footer = document.querySelector('.el-table__footer')
          const hideCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[2]
          const remarkCell =
            footer &&
            footer.querySelectorAll('td') &&
            footer.querySelectorAll('td')[3]
          if (hideCell) {
            hideCell.style.display = 'none'
          }
          if (remarkCell) {
            // 设置监听textarea，table进行自适应
            const observer = new ResizeObserver((entries) => {
              this.$nextTick(() => {
                this.$refs.contentTable && this.$refs.contentTable.doLayout()
              })
            })

            // 表格合并
            remarkCell.setAttribute('colspan', 2)

            // 设置输入框
            let cell = remarkCell.querySelector('.cell')
            let html = `<div class="ipt-wrap"><textarea class="ipt-noBorder" id="allowance_remark" type="text" maxlength="255" placeholder="请输入"></textarea><span class="ipt-count" id="allowance_count">${this.dataForm.userRemark.length}/255</span></div>`
            cell.innerHTML = html

            // 获取备注值方法
            const remarkEl = document.getElementById('allowance_remark')
            remarkEl.addEventListener('input', this.remarkChange)

            // 初始化值
            remarkEl.value = this.dataForm.userRemark

            // 监听 textarea 尺寸变化
            observer.observe(remarkEl)
          }
        })
      })

      return sums
    },
    remarkChange (e) {
      this.dataForm.userRemark = e.target.value || ''

      // 设置输入字数长度限制
      let remarkCount = document.getElementById('allowance_count')
      remarkCount.innerHTML = `${this.dataForm.userRemark.length}/255`
    },
    // 上传前校验
    beforeUpload (file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension1 = testmsg === 'pdf'
      const extension2 = testmsg === 'jpg'
      const extension3 = testmsg === 'rar'
      const extension4 = testmsg === 'zip'
      const extension5 = testmsg === 'doc'
      const extension6 = testmsg === 'docx'
      if (
        !extension1 &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5 &&
        !extension6
      ) {
        this.$message.warning('只能上传 .rar .zip .doc .docx .pdf .jpg 格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error('上传的附件不得大于20MB')
        return false
      }
    },
    // 上传成功回调
    onSuccess (res) {
      this.$nextTick(() => {
        console.log(this.$refs.uploadFile.list)
        const list = this.$refs.uploadFile && this.$refs.uploadFile.list
        if (
          list &&
          list[0] &&
          list[0].response &&
          list[0].response.data &&
          list[0].response.data.url
        ) {
          this.dataForm.attachUrl = list[0].response.data.url
        } else {
          this.dataForm.attachUrl = ''
        }
      })
    },
    // 提交需求
    goSumbmit () {
      const attrConfigs = this.dataList
        .map((item) => {
          let attrValue = item.attrValue || item.inputValue
          return {
            attrId: item.attrId,
            attrValue: attrValue,
            unit: item.unit
          }
        })
        .filter((item) => item.attrValue)
      if (attrConfigs.length === 0) {
        this.$message.warning('请填写至少一项参数值')
        return
      }
      this.submitLoading = true
      this.$http
        .post('/front/cross/commodity-user/design/demand/apply', {
          ...this.dataForm,
          productId: this.detailObj.productId,
          attrConfigs: attrConfigs
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$confirm(
              '您的需求已经提交成功，我们将尽快与您联系，请注意接听您在平台注册的手机来电！',
              '温馨提示',
              {
                confirmButtonText: '继续配置需求',
                cancelButtonText: '去查看',
                customClass: 'comfirm-box',
                type: 'warning'
              }
            )
              .then(() => {
                this.resetData()
              })
              .catch(() => {
                this.$router.push({ name: 'meterSelection' })
              })
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    // 重置配置
    resetData () {
      // 初始化数据
      const initialData = this.$options.data.call(this) // 获取初始数据
      Object.assign(this.$data, initialData) // 重置数据
      this.$refs.uploadFile.list = []

      // 获取数据
      this.$nextTick(() => {
        this.getDetail(this.$refs.categoryInfo.categoryTreeInfo[2].categoryId)
      })
    },
    // 参数示意点位
    itemPos (item) {
      // 点位的宽高
      const widthHeight = 6

      if (this.imgSize.width > this.imgSize.height) {
        return {
          left: item.xposition * this.imgSize.rate - widthHeight + 'px',
          top:
            item.yposition * this.imgSize.rate -
            widthHeight +
            ((this.imgSize.width - this.imgSize.height) * this.imgSize.rate) /
              2 +
            'px'
        }
      } else if (this.imgSize.width < this.imgSize.height) {
        return {
          left:
            item.xposition * this.imgSize.rate -
            widthHeight +
            ((this.imgSize.height - this.imgSize.width) * this.imgSize.rate) /
              2 +
            'px',
          top: item.yposition * this.imgSize.rate - widthHeight + 'px'
        }
      } else {
        return {
          left: item.xposition * this.imgSize.rate - widthHeight + 'px',
          top: item.yposition * this.imgSize.rate - widthHeight + 'px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  background: #f8f9fa;
  font-family: Alibaba PuHuiTi;

  .app-content-wrap {
    width: 1200px;
    padding: 10px 0;
    margin: 0 auto;

    .right-menu-name {
      padding: 8px 16px;
      color: #999;
      font-weight: bold;

      i {
        margin: 0 3px;
        color: #666;
      }

      span {
        color: #333;
      }
    }

    .app-content {
      background: #fff;
      border-radius: 8px;
      padding: 20px 24px;

      .content-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &-left {
          .tab {
            border-radius: 16px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            padding: 2px;
            background: #f5f6fa;
            user-select: none;

            .tab-meter-item {
              color: #666666;
              font-size: 14px;
              line-height: 19px;
              padding: 8px 16px;

              &.active {
                background: #2a54d1;
                border-radius: 14px;
                color: #ffffff;
              }
            }
          }

          .content-title {
            margin-top: 10px;
            padding-left: 8px;
            position: relative;
            font-size: 16px;
            font-weight: bold;
            color: #333;

            &::after {
              content: "";
              height: 12px;
              width: 1px;
              position: absolute;
              left: 0;
              top: 50%;
              background: #2a54d1;
              margin-top: -6px;
            }
          }

          &-form {
            margin-top: 13px;

            &-wrap {
              margin-top: 12px;

              .el-form-item {
                font-size: 14px;
                color: #666;
                font-weight: bold;
                margin-bottom: 12px;
                margin-right: 0;

                /deep/ .el-form-item__label {
                  padding: 0;
                  line-height: 36px;
                }

                /deep/ .el-form-item__content {
                  line-height: 36px;
                }

                .el-select {
                  width: 270px;

                  /deep/ input {
                    height: 36px;
                    line-height: 36px;
                    border-radius: 8px;
                    border: 1px solid rgba(204, 204, 204, 0.4);
                  }

                  /deep/ .el-input__icon {
                    line-height: 36px;

                    &::before,
                    &::after {
                      line-height: 36px;
                    }
                  }
                }

                /deep/ .el-icon-close-tip {
                  display: none;
                }
              }
            }
          }
        }

        &-right {
          display: flex;
          align-items: center;

          .content-show-img {
            text-align: center;

            &:first-child {
              margin-right: 20px;
            }

            .tip {
              font-size: 12px;
              color: #999999;
              transform: scale(0.75);
            }
          }
        }
      }

      .content-bottom {
        margin-top: 20px;
        display: flex;
        align-items: flex-start;

        .content-title {
          padding-left: 8px;
          position: relative;
          font-size: 16px;
          font-weight: bold;
          color: #333;

          &::after {
            content: "";
            height: 12px;
            width: 1px;
            position: absolute;
            left: 0;
            top: 50%;
            background: #2a54d1;
            margin-top: -6px;
          }
        }

        &-left {
          flex: 1;
          width: calc(100% - 504px);

          .content-title {
            &-count {
              font-size: 12px;
              margin-left: 4px;
              color: #2a54d1;
              display: inline-block;
              transform-origin: left bottom;
              transform: scale(0.75);
            }
          }

          .opts {
            display: flex;
            align-items: center;

            .btn-primary {
              margin-left: 6px;
              padding: 8px 12px;
              border-radius: 8px;
              color: #fff;
              // font-weight: bold;
              background: #284bb5;
              cursor: pointer;
              font-size: 14px;
              display: flex;
              align-items: center;
              line-height: 19px;

              &.btn-plain {
                background: #cccccc;
                cursor: not-allowed;
              }
            }
          }

          .content-config {
            margin-top: 10px;
            display: flex;
            flex-wrap: nowrap;

            &-attr {
              width: 280px;
              margin-right: 10px;
              display: flex;
              flex-direction: column;

              .config-menu {
                border-radius: 8px;
                margin-bottom: 10px;
                background: #f5f6fa;
                box-sizing: border-box;
                border: 1px solid rgba(204, 204, 204, 0.4);
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                color: #333333;
                padding: 8px 8px 8px 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .menu-count {
                  border-radius: 4px;
                  background: rgba(42, 84, 209, 0.15);
                  font-size: 14px;
                  line-height: 19px;
                  color: #2a54d1;
                  padding: 1px 5px;
                  font-weight: 500;
                  margin-left: 6px;
                }

                .btn-primary {
                  border-radius: 8px;
                  background: rgba(255, 255, 255, 0.9);
                  box-sizing: border-box;
                  border: 1px solid rgba(40, 75, 181, 0.4);
                  font-size: 14px;
                  line-height: 19px;
                  color: #284bb5;
                  font-weight: 500;
                  padding: 6px 8px;
                  width: 130px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  .el-icon-arrow-down {
                    transition: transform 0.3s, -webkit-transform 0.3s;
                  }

                  &:hover {
                    .el-icon-arrow-down {
                      transform: rotate(180deg);
                    }
                  }

                  .next-sign {
                    font-size: 12px;
                    transform: scale(0.8);
                    margin-left: -10px;
                  }

                  .btn-text {
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }

              .attr-item-wrap {
                border: 1px solid rgba(204, 204, 204, 0.4);
                border-radius: 8px;
                max-height: 419px;
                overflow-x: hidden;
                overflow-y: auto;
                flex: 1;
              }

              .attr-item {
                padding: 10px;
                cursor: pointer;
                position: relative;

                &::after {
                  content: "";
                  background: #e1e3e6;
                  height: 1px;
                  width: calc(100% - 16px);
                  position: absolute;
                  left: 8px;
                  bottom: -1px;
                }

                &:last-child {
                  &::after {
                    display: none;
                  }
                }

                &.selected {
                  background: rgba(36, 126, 101, 0.6);

                  .attr-name,
                  .attr-value {
                    color: #fff;
                  }
                }

                &.active {
                  background: rgba(42, 84, 209, 0.2);

                  .attr-name,
                  .attr-value {
                    color: #2a54d1;
                  }
                }

                .attr-name {
                  color: #3d3d3d;
                  font-size: 12px;
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-end;

                  .required {
                    font-size: 10px;
                    color: #666;

                    &.red {
                      color: #e93037;
                    }
                  }
                }

                .attr-value {
                  font-size: 10px;
                  color: #666;
                  display: flex;
                  white-space: nowrap;
                }
              }

              .empty {
                text-align: center;
                color: #3d3d3d;
                font-size: 12px;
                padding: 30px 0;
              }
            }

            &-attr-row {
              border-radius: 8px;
              border: 1px solid rgba(204, 204, 204, 0.4);
              height: 480px;
              flex: 1;
              overflow: hidden;

              .row-header {
                padding: 12px 16px;
                background: #284bb5;
                font-size: 14px;
                font-weight: 500;
                color: #ffffff;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .row-unit {
                  color: #dddddd;
                  display: flex;
                  align-items: center;

                  .el-select {
                    margin-left: 4px;

                    /deep/ input {
                      border-radius: 8px;
                      font-size: 8px;
                      padding: 0 8px;
                      background: rgba(255, 255, 255, 0.9);
                      box-sizing: border-box;
                      border: 1px solid rgba(238, 238, 238, 0.4);
                      height: 24px;
                      color: #284bb5;

                      &::placeholder {
                        color: #284bb5;
                        font-size: 8px;
                      }
                    }

                    /deep/ .el-input__icon {
                      line-height: 24px;

                      &::before,
                      &::after {
                        line-height: 24px;
                        color: #284bb5;
                      }
                    }
                  }
                }
              }

              .row-wrap {
                padding: 8px 16px;
                display: flex;
                flex-direction: column;
                height: calc(100% - 45px);

                .el-input {
                  padding: 4px 0;
                  color: #999;

                  /deep/ input {
                    height: 20px;
                    line-height: 20px;
                    border: none;
                    padding: 0;

                    &::placeholder {
                      color: #999;
                    }
                  }
                }

                .row-configDatas {
                  overflow-x: hidden;
                  overflow-y: auto;
                  display: flex;
                  flex-wrap: wrap;

                  .row-item {
                    border-radius: 8px;
                    padding: 6px 25px;
                    box-sizing: border-box;
                    border: 1px solid #cccccc;
                    font-size: 12px;
                    color: #666666;
                    margin: 6px 2px;
                    max-width: calc(100% - 4px);
                    cursor: pointer;
                    user-select: none;

                    &.active {
                      background: #2a54d1;
                      color: #fff;
                      border-color: #2a54d1;
                    }
                  }
                }
              }
            }
          }

          .content-table {
            margin-top: 10px;

            .el-table {
              border-radius: 8px;
              color: #3d3d3d;

              /deep/ .vertical-rl {
                writing-mode: vertical-rl;
                text-orientation: upright;

                .cell {
                  min-width: auto;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                }
              }

              /deep/ th.el-table__cell {
                background-color: #2a54d1;
                font-weight: 500;
              }

              /deep/ thead {
                color: #fff;
              }

              /deep/ .el-table__footer-wrapper {
                tbody td.el-table__cell {
                  background-color: #2a54d1;
                  color: #fff;

                  &:nth-child(4) {
                    background: #fff;

                    .cell {
                      overflow: visible;
                    }
                  }

                  .ipt-noBorder {
                    width: 100%;
                    height: 100%;
                    border: none;
                    resize: vertical;
                    min-height: 37px;
                    max-height: 100px;
                  }

                  .ipt-wrap {
                    position: relative;
                  }

                  .ipt-count {
                    color: #909399;
                    position: absolute;
                    font-size: 11px;
                    pointer-events: none;
                    bottom: -13px;
                    right: 0px;
                  }
                }
              }
            }
          }
        }

        &-right {
          width: 480px;
          margin-left: 24px;

          .btn-next {
            padding: 8px 12px;
            color: #fff;
            font-size: 14px;
            // font-weight: bold;
            border-radius: 8px;
            cursor: pointer;
            background: #2a54d1;
            margin-right: 20px;
            line-height: 19px;

            &.btn-primary {
              color: #7394f6;
              border: 1px solid rgba(187, 212, 255, 0.2);
              background: rgba(42, 84, 209, 0.0392);
            }

            &:last-child {
              margin-right: 0;
            }
          }

          .img-position-wrap {
            border-radius: 8px;
            margin-top: 10px;
            height: 480px;
            border: 1px solid rgba(204, 204, 204, 0.4);
            position: relative;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .img-pos {
              position: absolute;
              z-index: 1;
              align-items: center;
              justify-content: center;
              display: none;

              img {
                width: 12px;
                height: 12px;

                &.current {
                  display: none;
                }
              }

              &.show {
                display: flex;
              }

              &.current {
                img {
                  &.default {
                    display: none;
                  }

                  &.current {
                    display: inline-block;
                  }
                }
              }
            }

            .no_show_message {
              margin: 150px auto;
              text-align: center;
            }
          }

          .img-opt {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.meter-form-select-popper.el-select-dropdown {
  border: 1px solid rgba(204, 204, 204, 0.4);
  border-radius: 8px;
  z-index: 99 !important;

  .el-select-dropdown__empty {
    font-size: 12px;
    padding: 6px 0;
  }
}
.meter-group-wrap-popper.el-popover {
  padding: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;
  border: 1px solid rgba(40, 75, 181, 0.4);
  overflow: hidden;
  min-width: 120px;
  // z-index: 99!important;

  .popper__arrow {
    display: none;
  }

  .meter-group-wrap {
    padding: 4px;

    .meter-group-item {
      padding: 4px;
      font-size: 14px;
      line-height: 19px;
      color: #666;
      cursor: pointer;
      border-radius: 4px;
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }

      .el-icon-check {
        display: none;
        font-size: 12px;
      }

      &.active {
        background: #284bb5;
        color: #feffff;

        .el-icon-check {
          display: inline-block;
        }
      }
      &:hover {
        background: #284bb5;
        color: #feffff;
      }
    }
  }
}
</style>
